import React from "react";

/**
 * Single majolica (Amalfi/Vietri) ceramic tile motif.
 * Renders an SVG <symbol> + a tiled band component.
 * Pure CSS friendly — used as decorative footer/section border.
 */
const TileMotif = ({ id, deep, light }) => (
  <symbol id={id} viewBox="0 0 100 100">
    {/* base background */}
    <rect width="100" height="100" fill="#FFFFFF" />
    {/* corner triangles */}
    <path d="M0 0 L 22 0 L 0 22 Z" fill={light} opacity="0.55" />
    <path d="M100 0 L 78 0 L 100 22 Z" fill={light} opacity="0.55" />
    <path d="M0 100 L 22 100 L 0 78 Z" fill={light} opacity="0.55" />
    <path d="M100 100 L 78 100 L 100 78 Z" fill={light} opacity="0.55" />

    {/* central star/rosette */}
    <g transform="translate(50 50)">
      {/* outer 8-petal */}
      {Array.from({ length: 8 }).map((_, i) => (
        <ellipse
          key={i}
          cx="0"
          cy="-28"
          rx="6"
          ry="14"
          fill={deep}
          opacity="0.85"
          transform={`rotate(${i * 45})`}
        />
      ))}
      {/* mid ring */}
      <circle r="15" fill="#FFFFFF" stroke={deep} strokeWidth="1.2" />
      {/* inner star */}
      {Array.from({ length: 4 }).map((_, i) => (
        <path
          key={i}
          d="M-3 0 L 0 -12 L 3 0 L 0 12 Z"
          fill={deep}
          transform={`rotate(${i * 45})`}
        />
      ))}
      <circle r="3" fill={light} />
    </g>

    {/* edge mid-leaves */}
    <path d="M50 4 L 56 14 L 50 24 L 44 14 Z" fill={light} opacity="0.7" />
    <path d="M50 76 L 56 86 L 50 96 L 44 86 Z" fill={light} opacity="0.7" />
    <path d="M4 50 L 14 56 L 24 50 L 14 44 Z" fill={light} opacity="0.7" />
    <path d="M76 50 L 86 56 L 96 50 L 86 44 Z" fill={light} opacity="0.7" />

    {/* tile border */}
    <rect x="0.5" y="0.5" width="99" height="99" fill="none" stroke={deep} strokeWidth="0.8" />
  </symbol>
);

/**
 * Horizontal band of repeating majolica tiles — pure SVG, decorative only.
 */
export const MajolicaBand = ({ className = "", tiles = 18, height = 64 }) => {
  const deep = "#1F5C8A";
  const light = "#7FB3D0";
  return (
    <svg
      aria-hidden="true"
      viewBox={`0 0 ${tiles * 100} 100`}
      preserveAspectRatio="none"
      className={className}
      style={{ height, width: "100%", display: "block" }}
    >
      <defs>
        <TileMotif id="majolica-tile" deep={deep} light={light} />
      </defs>
      {Array.from({ length: tiles }).map((_, i) => (
        <use key={i} href="#majolica-tile" x={i * 100} y="0" width="100" height="100" />
      ))}
    </svg>
  );
};

export default MajolicaBand;
